<div class="kb-page kb-gateway od-root" *ngIf="activa$ | async as activa">
  <header class="od-head">
    <h1>Odoo</h1>
    <p>Los clientes y comercios que se anotan en Odoo, y los archivos que se le entregan cada día.</p>
  </header>

  <div class="od-tabs" role="tablist" aria-label="Secciones de Odoo">
    <button type="button" class="od-tab" role="tab" *ngFor="let p of pestanas; trackBy: porId"
            [id]="'od-tab-' + p.id" [attr.aria-selected]="activa === p.id" [attr.aria-controls]="'od-panel'"
            [attr.tabindex]="activa === p.id ? 0 : -1"
            (click)="irA(p.id)" (keydown)="teclas($event, activa, pestanas)">
      <od-icon [name]="p.icono"></od-icon><span>{{ p.texto }}</span>
    </button>
  </div>

  <div class="od-seccion" id="od-panel" role="tabpanel" [attr.aria-labelledby]="'od-tab-' + activa">
    <app-odoo-clientes *ngIf="activa === 'clientes'"></app-odoo-clientes>
    <app-odoo-comercios *ngIf="activa === 'comercios'"></app-odoo-comercios>
    <app-odoo-archivos *ngIf="activa === 'archivos'"></app-odoo-archivos>
    <app-odoo-bitacora *ngIf="activa === 'bitacora'"></app-odoo-bitacora>
    <app-odoo-config *ngIf="activa === 'config'"></app-odoo-config>
  </div>
  <app-odoo-toast></app-odoo-toast>
</div>
